const isDataUrl = s => !!s.match(isDataUrl.regex)

/* eslint no-useless-escape: 0 */
isDataUrl.regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;

export default isDataUrl